import React from 'react';

import Banner from './components/Banner';
import Header from './components/Header';
import Nav from './components/Nav';
import About from './components/About';
import Techs from './components/Techs';
import Work from './components/Work';
import Contact from './components/Contact';
import Footer from './components/Footer';

import './index.css';

const App = () => {
	return (
		<div className="bg-site bg-center bg-no-repeat bg-cover overflow-hidden">
			<Header />
			<Banner />
			<Nav />
			<About />
			<Techs />
			<Work />
			<Contact />
			<Footer />
		</div>
	);
};

export default App;
